export default __webpack_public_path__ + "static/media/fishtv.d83c9a61.png";